import { notification } from 'antd';

import { isValidElement } from 'react';
import { CloseIcon } from '../assets/icons';

const isValidDescription = (description) => {
  return typeof description === 'string' || isValidElement(description);
};

// Optional `key`: toasts sharing a key replace each other instead of stacking.
export const toastNotify = (type, description, key) => {
  if (!description || !isValidDescription(description)) {
    return;
  }

  const width = window.innerWidth;
  switch (type) {
    case 'success':
      notification.success({
        message: '',
        description: description,
        duration: '5',
        placement: width > 1024 ? 'bottomRight' : 'topRight',
        key,
      });
      break;
    case 'error':
      notification.error({
        message: '',
        description: description,
        duration: '5',
        placement: width > 1024 ? 'bottomRight' : 'topRight',
        key,
      });
      break;
    case 'info':
      notification.info({
        message: '',
        description: description,
        duration: '5',
        placement: width > 1024 ? 'bottomRight' : 'topRight',
        key,
      });
      break;
    case 'notifyMe':
      notification.open({
        message: '',
        className: 'bottom-notification',
        description: description,
        duration: '5',
        placement: width > 1024 ? 'bottomRight' : 'topRight',
        closeIcon: <CloseIcon color='#ffffff' size={20} />,
      });
      break;
    case 'newAgreement':
      notification.info({
        message: 'Secondary Listing Agreement',
        description: description,
        duration: null,
        placement: width > 1024 ? 'bottomRight' : 'topRight',
        key: 'newAgreement',
      });
      break;
    default:
      break;
  }
};
